.disclosure {
  min-width: 0;
  border-top: var(--border-default) solid var(--color-border-subtle);
}

.heading {
  margin: 0;
  font: inherit;
}

.trigger {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  min-height: var(--target-min);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-content-primary);
  font: var(--type-compact);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.trigger[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--focus-ring-inner, var(--color-bg-surface));
  border-radius: var(--radius-small);
}

.chevron {
  flex: none;
  color: var(--color-content-secondary);
  transition: transform var(--motion-fast) var(--motion-ease);
}

.disclosure[data-expanded] .chevron {
  transform: rotate(90deg);
}

.panel {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}

.panel[aria-hidden='false'],
.panel:not([hidden]) {
  padding-bottom: var(--space-4);
}

.disclosure[data-bare] {
  border-top: 0;
}
